import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers"
import "bootstrap-slider/dist/css/bootstrap-slider.min.css"
import "./slider.scss"

const context = require.context('./', true, /_controller\.js$/)
application.load(definitionsFromContext(context))
